import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { PostServiceCaller } from "../../../services/serviceCaller";
import { API_URL } from "../../../constants";
import { toast } from "react-toastify";
import { updateNavbarHeading } from "../../../constants/layout/store/filterSlice";

const Announcements = () => {
  const dispatch = useDispatch();


    useEffect(() => {
      dispatch(updateNavbarHeading("Announcement"));
    }, []);
  const [formData, setFormData] = useState({
    MsgDetails: "",
  });

  console.log("formData", formData); // Corrected log message

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      response = await PostServiceCaller(
        `${API_URL}post-announcement`,
        formData,
        "post"
      );
      if (response?.status === 201) {
        toast.success("Data Submitted Successfully");
      }
    } catch (error) {
      console.error("Data Posting Error", error);
    }
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div style={{ width: "50vw" }}>
          <form
            className="rounded bg-white mx-3 mt-3"
            onSubmit={handleSubmit} // Un-commented to handle form submission
          >
            <div className="d-flex justify-content-center">
              <div className="row">
                <div className="col-12">
                  <div className="d-flex justify-content-center">
                    <label className="form-label">Announcement</label>
                  </div>
                  <div className="d-flex justify-content-center">
                    <textarea
                      name="MsgDetails"
                      rows="4"
                      className="form-control"
                      style={{ width: "500px", height: "200px" }} // Set rectangular size
                      value={formData.MsgDetails}
                      onChange={handleChange} // Simplified
                    />
                  </div>
                  <div className="p-2 mt-2 d-flex justify-content-center">
                    <button
                      type="button" // Added type to prevent form submission
                      className="me-2 custom-btn"
                      onClick={handleSubmit}
                    >
                      To My Team
                    </button>
                    <button
                      type="button" // Added type to prevent form submission
                      className="me-2 custom-btn"
                      onClick={handleSubmit}
                    >
                      To My Manager
                    </button>
                    <button
                      type="button" // Added type to prevent form submission
                      className="custom-btn"
                      onClick={handleSubmit}
                    >
                      To My Test
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Announcements;
